/**
 * Affiche le contenu du panier
 */
const loadPanierList = async () => {

    const resp = await fetch(Routing.generate('shop_cart_list', {
        isShoppingCartPage: document.getElementById('isShoppingCartPage').value
    }));

    const html = await resp.text();
    document.getElementById('contentPanier').innerHTML = html;

    loadPanierEvent();
    NotifPanier.load();
};

/**
 * Update quantity
 */
const updateArticleQuantity = async (elm) => {
    Notiflix.Loading.dots();
    const id = elm.dataset.id;
    const formData = new FormData();
    formData.set('quantite', elm.value);
    await fetch(Routing.generate('shop_cart_edit', {
        id: id
    }), {
        method: 'POST',
        body: formData
    });

    loadPanierList().then(() => {
        Notiflix.Loading.remove();
    });
};

/**
 * Init event panier
 */
const loadPanierEvent = () => {

    // Supprime un article
    document.querySelectorAll('.btn-remove-article').forEach((elm) => {
        elm.addEventListener('click', async (e) => {
            const id = e.currentTarget.dataset.id;
            Notiflix.Confirm.show(
                'Attention',
                'Souhaitez-vous retirer cet article ?',
                'Oui',
                'Non',
                async () => {
                    Notiflix.Loading.dots();
                    await fetch(Routing.generate('shop_cart_remove', {
                        id: id
                    }), {
                        method: 'DELETE'
                    });
                    loadPanierList().then(() => {
                        Notiflix.Loading.remove();
                    });
                },
                () => {
                }
            );
        });
    });

    // Modifie la quantité 
    document.querySelectorAll('.input-quantite').forEach((elm) => {
        elm.addEventListener('input', async (e) => {
            updateArticleQuantity(e.currentTarget);
        });
    });
    
    // Input spin
    $('.spinner-ctn')
    .spinner({
        //delay: 200,
        min: 1
    }) // delay in ms
    .spinner('changed', function(e, newVal, oldVal) {
        updateArticleQuantity(e.currentTarget);
    })
    .spinner('changing', function(e, newVal, oldVal) {
      // trigger immediately
    });

};
loadPanierEvent();
